// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GQ7E","title":"styles_title__2Gu4D"};